import React from "react";

const Manual = () => {
    return <div className = 'body'>справка</div>;
}

export default Manual;
